var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"alert alert-primary shadow-none border-left-lg border-left-primary rounded-lg p-2 m-1 mb-2"},[_c('i',{staticClass:"fa fa-info-circle fa-fw text-primary animate__animated animate__heartBeat animate__infinite"}),_c('span',[_vm._v("Víctima del conflicto armado.")])])])
}]

export { render, staticRenderFns }